<div *ngIf="forms && !readOnly">
  <ng-container *ngIf="forms.controls.length > 0; else emptyBatch">
    <ng-container *ngFor="let batchFormGroup of formsSorted; let i = index">
      <app-batch-selector
        [showExpirationDate]="showExpirationDate"
        [readOnly]="readOnly"
        [hideLabel]="!showType(i)"
        [form]="getFormGroupFromAbstractControl(batchFormGroup)"
        (onChange)="onSomeChange()">
      </app-batch-selector>
    </ng-container>
  </ng-container>
</div>

<div *ngIf="forms && readOnly" class="grid-read-only">
  <ng-container *ngIf="forms.controls.length > 0; else emptyBatch">
    <ng-container *ngFor="let batchFormGroup of formsSorted; let i = index">
      <div class="batch-read-only-item">
        <div class="batch-info">
          <span *ngIf="showType(i)">{{ BatchType.getBatchTypeReadable(getBatchType(batchFormGroup)) }}</span>
        </div>
        <div class="batch-number">
          <b>{{ getBatchNumber(batchFormGroup) }}</b>
        </div>
        <div *ngIf="getPlatesSuffixes(batchFormGroup)?.length > 0" class="plates-info">
          Platten: {{getPlatesSuffixes(batchFormGroup)}}
        </div>
      </div>
    </ng-container>
  </ng-container>
</div>

<ng-template #emptyBatch>
  <ng-container *ngIf="readOnly">Keine Chargen verwendet</ng-container>
  <ng-container *ngIf="!readOnly">Noch keine Chargen importiert</ng-container>
</ng-template>
